import Overview from './Overview.vue'
import Base from './Base.vue'
import Edit from './Edit.vue'

export default {
    Overview,
    Base,
    Edit
}


// WEBPACK FOOTER //
// ./src/views/customer/preOrders/index.js